export default "__VITE_ASSET__Bn5o74tw__"